import {getMockSubscriptionsSingleton} from './getMockSubscriptionsSingleton';

export const unsubcribeAllMock = () => {
  console.log('Unsubscribing from all');
  const subscriptionsSingleton = getMockSubscriptionsSingleton();

  const keys = Object.keys(subscriptionsSingleton);
  keys.forEach(key => {
    delete subscriptionsSingleton[key];
  });
};
